import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class ServiceStore {
    loading = false;
    fieldsLoading = false;
    success = false;

    branches = [];

    getBranches = () => {
        this.fieldsLoading = true;

        Api.fetch('branch')
            .then(response => {
                if (response.success) {
                    this.branches = response.result;
                }
            })
            .catch(err => {
                if (err.error === 'RETRY_LATER') {
                    this.branches = [{ id: 0, name: 'Не удалось получить список. Повторите попытку еще раз' }];
                }
            })
            .finally(() => {
                this.fieldsLoading = false;
            });
    };

    send = (data, onSuccess) => {
        this.loading = true;

        Api.fetch('tech', data, 'POST')
            .then(response => {
                if (response.success) {
                    this.success = true;
                    onSuccess();
                }
            })
            .finally(() => {
                this.loading = false;
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            });
    };

    resetStore = () => {
        this.loading = false;
        this.fieldsLoading = false;
        this.branches = [];
    };
}

decorate(ServiceStore, {
    loading: observable,
    fieldsLoading: observable,
    success: observable,

    branches: observable,

    getBranches: action,
    send: action,
    resetStore: action,
});
